import {
    ConfirmationPageReferralExperimentVariant,
    EnhanceLogionOptionExperimentVariant,
    ExpressOnlyCheckoutExperimentVariant,
    ExpressPaymentMethods,
    FollowCardPlacementExperimentVariant,
    PostCheckoutMandatoryQuestionsInAppVariant,
    ScalableExpressCheckoutExperimentVariant,
    StripeElementsAustraliaExperimentVariant,
    StripeElementsCanadaExperimentVariant,
    StripeElementsEuroExperimentVariant,
    StripeElementsNewZealandExperimentVariant,
    StripeElementsUKExperimentVariant,
    StripeElementsUnitedStatesExperimentVariant,
} from './types';

const ORDER_FORM_PAGE_EXPERIMENTS_LAYER = 'checkout_checkout_page_experiments';
const ORDER_CONFIRMATION_PAGE_EXPERIMENTS_LAYER =
    'checkout_order_confirmation_page_experiments';
const TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER =
    'checkout_ticket_selection_page_experiments';

export const GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT = {
    defaultValue: ExpressPaymentMethods.paypal,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'express_gpay_or_paypal',
};

export const POST_CHECKOUT_MANDATORY_QUESTIONS_IN_ANDROID_APP = {
    defaultValue:
        PostCheckoutMandatoryQuestionsInAppVariant.optionalQuestionsInApp,
    experiment: 'post_checkout_mandatory_questions_android_app',
    param: 'post_checkout_page_questions_in_app',
};

export const FOLLOW_CARD_PLACEMENT_EXPERIMENT = {
    defaultValue: FollowCardPlacementExperimentVariant.topFollowCard,
    layer: ORDER_CONFIRMATION_PAGE_EXPERIMENTS_LAYER,
    param: 'follow_card_placement',
};

export const ORDER_CONFIRMATION_PAGE_REFERRAL_EXPERIMENT = {
    defaultValue: ConfirmationPageReferralExperimentVariant.control,
    experiment: 'referrals_in_order_confirmation',
    param: 'variant_to_show',
};

export const EXPRESS_CHECKOUT_ONLY_CHECKOUT_EXPERIMENT = {
    defaultValue: ExpressOnlyCheckoutExperimentVariant.notEnabled,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'express_only_checkout',
};

export const ENHANCE_LOGIN_OPTION_IN_CHECKOUT_EXPERIMENT = {
    defaultValue: EnhanceLogionOptionExperimentVariant.control,
    experiment: 'enhance_login_option_in_checkout',
    param: 'enhance_login_option',
};

export const SCALABLE_EXPRESS_CHECKOUT_EXPERIMENT = {
    defaultValue: ScalableExpressCheckoutExperimentVariant.control,
    experiment: 'express_checkout_milestone_1',
    param: 'express_checkout_applepay',
};

export const STRIPE_ELEMENTS_AUSTRALIA_EXPERIMENT = {
    defaultValue: StripeElementsAustraliaExperimentVariant.control,
    layer: ORDER_FORM_PAGE_EXPERIMENTS_LAYER,
    param: 'show_stripe_elements_australia',
};

const STRIPE_ELEMENTS_UNITED_STATES_EXPERIMENTS_LAYER =
    'payments_stripe_elements_us_experiments';
export const STRIPE_ELEMENTS_UNITED_STATES_EXPERIMENT = {
    defaultValue: StripeElementsUnitedStatesExperimentVariant.control,
    layer: STRIPE_ELEMENTS_UNITED_STATES_EXPERIMENTS_LAYER,
    param: 'show_stripe_elements_united_states',
};

const STRIPE_ELEMENTS_NEW_ZEALAND_EXPERIMENTS_LAYER =
    'payments_stripe_elements_nz_experiments';
export const STRIPE_ELEMENTS_NEW_ZEALAND_EXPERIMENT = {
    defaultValue: StripeElementsNewZealandExperimentVariant.control,
    layer: STRIPE_ELEMENTS_NEW_ZEALAND_EXPERIMENTS_LAYER,
    param: 'show_stripe_elements_new_zealand',
};

const STRIPE_ELEMENTS_UK_EXPERIMENTS_LAYER =
    'payments_stripe_elements_uk_experiments';
export const STRIPE_ELEMENTS_UK_EXPERIMENT = {
    defaultValue: StripeElementsUKExperimentVariant.control,
    layer: STRIPE_ELEMENTS_UK_EXPERIMENTS_LAYER,
    param: 'show_stripe_elements_uk',
};

const STRIPE_ELEMENTS_CANADA_EXPERIMENTS_LAYER =
    'payments_stripe_elements_canada_experiments';
export const STRIPE_ELEMENTS_CANADA_EXPERIMENT = {
    defaultValue: StripeElementsCanadaExperimentVariant.control,
    layer: STRIPE_ELEMENTS_CANADA_EXPERIMENTS_LAYER,
    param: 'show_stripe_elements_canada',
};

const STRIPE_ELEMENTS_EURO_EXPERIMENTS_LAYER =
    'payments_stripe_elements_euro_experiments';
export const STRIPE_ELEMENTS_EURO_EXPERIMENT = {
    defaultValue: StripeElementsEuroExperimentVariant.control,
    layer: STRIPE_ELEMENTS_EURO_EXPERIMENTS_LAYER,
    param: 'show_stripe_elements_euro',
};
